import * as React from "react";
const SvgLaserDrillHole = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 69, cy: 67, r: 12, style: {
  stroke: "red",
  fill: "red"
}, transform: "translate(-5 -3)" }), /* @__PURE__ */ React.createElement("circle", { cx: 61, cy: 66, r: 26, style: {
  stroke: "#390",
  strokeWidth: 3,
  fill: "none"
}, transform: "translate(3 -2)" }));
export default SvgLaserDrillHole;
